import React, {useEffect, useState} from 'react'
import { Nav, Tab } from "react-bootstrap";
import Skeleton from 'react-loading-skeleton';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { BackIcon, SpinnerIcon } from '../../../assets/icons/iconshere'
import DateRangeSelector from '../filterDataRange/DateRangeSelector';
import { EXLDownloadIcon, PDFDownloadIcon } from '../../../SvgIconsData';
import { useSelector } from 'react-redux';
import LearningProductivity from './Charts/LearningProductivity';
import UsersStatGraph from './Charts/UsersStatGraph';
import TimeSpentLearning from './Charts/TimeSpentLearning';
import axios from 'axios';
import CertifiedUsers from '../Admin/CertifiedUsers';
import GroupFileTab from "../group/GroupFileTab";
import UserFileTab from "../user/UserFileTab";
import moment from 'moment';
import { exportMultipleChartsToPdf, generateExcel } from '../../../utils/pdf';
import { BsArrowsAngleExpand } from 'react-icons/bs';

const LMSTeamDashboard = () => {
    const [activeTab, setActiveTab] = useState("Dashboard");
    var location = useLocation();
    const userData = useSelector((state) => state.userSlice);
    const configData = useSelector((state) => state.configSlice);
    const MODE = configData.config.MODE;
    const params = useParams();
    const { groupId } = params;
    const navigate = useNavigate();
    if (!location?.state?.uuid) navigate(`/team-dashboard/${userData.user.group.uuid}`, { state: userData.user.group });
    const [filter, setFilter] = useState("all");
    const [dashboardAnalytics, setDashboardAnalytics] = useState({
      modules:[]
    });
    const [chartAnalytics, setChartAnalytics] = useState({});
    const [loadingChart, setLoadingChart] = useState(true);
    const [loadingTeam, setLoadingTeam] = useState(true);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");
    const [groupLength, setGroupLength] = useState(0)
    const [groupTypesList, setGroupTypesList] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [userLength, setUserLength] = useState(0)
    const [openPro, setOpenPro] = useState(false);
    const [pdfSpinner, setPdfSpinner] = useState(false);
    const [excelSpinner, setExcelSpinner] = useState(false);
    const [userPlan, setUserPlan] = useState(null);
    const [labels, setWeekdays] = useState([]);
    const [skillStreamCounts, setSkillStreamCounts] = useState([]);
    let group = location?.state || null

    const geGroupTypeList = async () => {
      try {
        let { data } = await axios.get(`${configData.config.UNO_URL}/api/role/grouptype/list`, {
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type": "application/json",
          },
        });
        setGroupTypesList(data?.data?.groupTypes || []);
      } catch (error) {
        console.log(error);
      }
    };

    const onGroupSelect = (group) => {
      if(MODE === "XR"){
        navigate(`/team-dashboard/${group.uuid}`, { state: group });
      }else if(MODE === "2D"){
        navigate(`/2d/lms/team-dashboard/${group.uuid}`, { state: group });
      }
    };

    const arr = [];

    const { modules } = dashboardAnalytics;
    modules.sort((a, b) => { return b.certificates - a.certificates });
    modules.map((e, i) => { arr.push([e.name, e.certificates]) });

    const onUserSelect = (user) => {
      if(MODE === "XR"){
        navigate(`/team/user/${user.uuid}`, { state: user });
      }else if(MODE === "2D"){
        navigate(`/2d/lms/team/user/${user.uuid}`, { state: user });
      }
    };

    useEffect(()=>{
      geGroupTypeList();
    },[]);


    const getTeamDashboardAnalytics = async () => {
      try {
        setLoadingTeam(true);
        
        let { data } = await axios.get(`${configData.config.API_URL}/api/dashboard/group/${configData.config.MODE}/${groupId}?filter=${filter}`,{
            headers: {
              Authorization: `Bearer ${userData.token}`,
              "Content-Type": "application/json",
            },
          }
        );
        setDashboardAnalytics({ ...data });
      } catch (error) {
        console.log(error);
      }
      setLoadingTeam(false);
    };

    const setDefaultData = () =>{
      setFilter("all");
      setActiveTab("Dashboard");
      setWeekdays([]);
      setSkillStreamCounts([]);
      setChartAnalytics({});
      setDashboardAnalytics({
        modules:[]
      });

    }

    useEffect(() => {
      setDefaultData();
      getTeamDashboardAnalytics();
    }, [groupId]);


    const getChartAnalytics = async () => {
      setChartAnalytics({});
      setLoadingChart(true);
      try {
        let { data } = await axios.get(
          `${configData.config.API_URL}/api/dashboard/group/charts/${configData.config.MODE}/${groupId}?filter=${filter}`,
          {
            headers: {
              Authorization: `Bearer ${userData.token}`,
              "Content-Type": "application/json",
            },
          }
        );
        setChartAnalytics({ ...data });
      } catch (error) {
        console.log(error);
      }
      setLoadingChart(false);
    };

    useEffect(() => {
      getChartAnalytics();
    }, [filter]);

    function extractData(analytics) {    
      const labels = [];
      const skillStreamCounts = [];
      analytics?.forEach((day) => {
        labels.push(day.label);
        skillStreamCounts.push(day.counts.skillStream  );
      });
      return { labels, skillStreamCounts };
    }

    useEffect(() => {
      const { labels, skillStreamCounts } = extractData(chartAnalytics?.counts?.chart);
      setWeekdays(labels);
      setSkillStreamCounts(skillStreamCounts);
    }, [chartAnalytics]);


    const tableData1 = [
      ["Team Dashboard", ""],
      ["Team Name", location?.state?.name],
      ["Report Generated at", moment().format("lll")],
      ["Date Range", `${moment(chartAnalytics?.start).format('D/M/YYYY')}-${moment(chartAnalytics?.end).format('D/M/YYYY')}`],
      ["Total Trainings", chartAnalytics?.counts?.total?.all ?? 0],
      ["Total Registered Users", chartAnalytics?.users?.total?.total ?? 0],
      ["Active Users", chartAnalytics?.users?.total?.active ?? 0],
      ["Inactive Users", chartAnalytics?.users?.total?.inactive ?? 0],
      ["Time Spent - Total ", chartAnalytics?.duration?.total?.all?.sum?.humanReadable ?? 0],
    ];
   
    const tableData2 = [["Courses", "No.of Certified Users"], ...arr];
    
    const handleClickPdfDownload = async(name, table1, table2) => {  
      setPdfSpinner(true);
      await exportMultipleChartsToPdf(name, table1, table2)
      setPdfSpinner(false);
    }
    
    const handleClickExcelDownload = async(name, table1, table2) => {
      setExcelSpinner(true);
      await generateExcel(name, table1, table2)
      setExcelSpinner(false);
    }

  return (
    <div className="container-fluid p-0">
      <div className="col-md-12">
      <Tab.Container id="my-tabs" activeKey={activeTab} defaultActiveKey="Dashboard">
        <div className="col-md-12">
            <Nav className="tabsproduct updated toptab" variant="tabs">
            <Nav.Item>
                <Nav.Link onClick={() => setActiveTab("Dashboard")} eventKey="Dashboard">
                Dashboard
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link onClick={() => setActiveTab("Groups")} eventKey="Groups">
                    Groups { !loadingTeam && <span>({groupLength})</span> }
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link onClick={() => setActiveTab("Users")} eventKey="Users">
                Users { !loadingTeam && <span>({userLength})</span> }
                </Nav.Link>
            </Nav.Item>
            </Nav>
        </div>

        <div className="container-fluid admindashboard pt-0 bg-grey-main">
        <Tab.Content className="pt-3 ">
          <Tab.Pane eventKey="Dashboard">
              <div className="row">
              <div className="bg-grey-main dashboard p-3 px-0">
                <div className="container-fluid">

                <div className="row py-2 mt-3 pb-2">
                  <div className="col-md-6 d-flex align-items-center">
                  {groupId !== userData.user.group.uuid && (
                      <button
                          className="backbtn cursor-pointer ps-2 mt-2"
                          title="Back"
                          onClick={() => navigate(-1)}>
                          <BackIcon/> Back
                      </button>
                   )}
                  </div>

                  <div className="col-md-6 d-flex gap-2 align-items-center" >
                  <DateRangeSelector selected={filter} setSelected={setFilter} />
                  <button
                    className="DefaultRedBtn download px-2"
                    title="Download PDF"
                    onClick={() => handleClickPdfDownload("User_Dashboard", tableData1, tableData2)}
                    >
                    {pdfSpinner ? <SpinnerIcon /> : <PDFDownloadIcon />}
                  </button>
                    <button
                      className="DefaultRedBtn download px-2"
                      title="Download Excel"
                      onClick={() => handleClickExcelDownload("User_Dashboard", tableData1, tableData2)}
                    >
                    {excelSpinner ? <SpinnerIcon /> : <EXLDownloadIcon />}
                  </button>
                  </div>
                </div>

                <div className="row pt-2">
                <div className="col-md-12 mb-2">
                  <div className='datacardesign py-2'>
                    <div className="row justify-content-between">

                      <div className="col-md-5 d-flex align-items-center ">


                      <div className='cardimages d-flex align-items-center gap-3 ps-3'>
                          {loadingTeam ? 
                          <Skeleton count={1} circle height="4.5vw" width="4.5vw" />  
                          : <>
                            {
                            group?.avatar ? (
                              <div className="groupcardesign m-0" style={{ height: "auto" }}>
                              <div className='avatarimg m-0' >
                                  <img src={group?.avatar} referrerPolicy={'no-referrer'} alt='' />
                              </div>
                              </div>
                              ) : (
                                  <div className="usercardesign m-0" style={{ height: "auto" }}>
                                      <div className='initials-placeholder'>
                                      {group?.name?.split(' ').map(word => word[0]).slice(0, 2).join('')}
                                  </div>
                                  </div>
                              )
                            }
                            </>
                          }

                          <h4 className=" group-user-name m-0">{loadingTeam ? <Skeleton count={1} width="10vw" /> : <> {group.name} </> }</h4>
                      </div>

                      </div>

                      <div className="col-md-7">
                        <div className="dashstatdata">
                          <div className="welcometext ">
                            <p>{loadingTeam ? <Skeleton width="5vw" /> : <> Total Training Duration </>} </p>
                            <h4>{loadingTeam ? <Skeleton width="5vw" /> :  dashboardAnalytics?.duration?.all?.sum?.humanReadable || 0 }</h4>
                          </div>
                          <div className="welcometext">
                            <p>{loadingTeam ? <Skeleton width="5vw" /> : <> Courses </>} </p>
                            <h4>{loadingTeam ? <Skeleton width="5vw" /> :  dashboardAnalytics?.length || 0  }</h4>

                          </div>
                        </div>
                     </div>
                    </div>
                  </div>
                </div>
                </div>
                
                <div className="row admincharts mt-2">
                  <div className=" col-lg-12 col-xl-9 col-xxl-9 ">
                      <div className="row">
                          
                          <div className="col-md-6">
                          <div className="cardbox overflow-hidden custom-chart">
                          <div className="d-flex justify-content-between align-items-center">
                          <h5> { loadingChart ? <Skeleton width="5vw"/> : <> Trainings </> }</h5> 
                          <p className="mb-1 d-flex align-items-flex">
                              { loadingChart ? <Skeleton width="5vw"/> : <> 
                              Total Learners : {chartAnalytics?.counts?.total?.all || 0 } 
                              {chartAnalytics?.counts?.total?.all ?? 0 > 0 ?
                                          <span className='ms-3 enlargebtn' onClick={() => navigate(`/total-trainings-list/${groupId}`, { state: { filter: filter || null, group: group || null } })}><BsArrowsAngleExpand /></span>
                                          : null
                                        }
                              
                              </> } 
                          </p>
                          </div>
                            <LearningProductivity labels={labels} skillStreamCounts={skillStreamCounts} />
                          </div>
                          </div>

                          <div className="col-md-6">
                          <div className="cardbox overflow-hidden custom-chart">
                          <div className="d-flex justify-content-between align-items-center">
                          <h5> { loadingChart ? <Skeleton width="5vw"/> : <> Registered Users </> }</h5> 
                          <p className="mb-1">
                              { loadingChart ? <Skeleton width="5vw"/> : <> Total Users : {chartAnalytics?.users?.total?.total || 0}  </> } 
                          </p>
                          </div>
                          <UsersStatGraph chartAnalytics={chartAnalytics} />
                          </div>
                          </div>

                          <div className="col-md-12 mt-3">
                          <div className="cardbox overflow-hidden custom-chart">
                          <div className="d-flex justify-content-between align-items-center">
                          <h5> { loadingChart ? <Skeleton width="5vw"/> : <> Time Spent Learning </> }</h5> 
                          <p className="mb-1"> { loadingChart ? <Skeleton width="5vw"/> : <> Total Time : {chartAnalytics?.duration?.total?.all?.sum?.humanReadable || 0} </> } </p>
                          </div>
                          <TimeSpentLearning chartLabels={chartAnalytics?.duration?.chart ?? []}  />
                          </div>
                          </div>

                      </div>
                      </div>

                      <div className=" col-lg-12 col-xl-3 col-xxl-3 ">
                        <div className="cardbox position-relative h-100">
                          <CertifiedUsers certifiedUsersCount={modules} loadingChart={loadingChart} />
                        </div>
                      </div>
                </div>
                </div>
              </div>
              </div>
          </Tab.Pane>

          <Tab.Pane eventKey="Groups">
              <GroupFileTab
                groupTypesList={groupTypesList}
                setSearch={setSearch}
                search={search}
                onSelect={(group) => onGroupSelect(group)}
                setGroupLength={setGroupLength}
              />
          </Tab.Pane>

          <Tab.Pane eventKey="Users">
              <UserFileTab
                roleList={roleList}
                setSearch={setSearch}
                search={search}
                onSelect={(user) => onUserSelect(user)}
                userLength={userLength}
                setUserLength={setUserLength}
              />
          </Tab.Pane>

        </Tab.Content>
        </div>


      </Tab.Container>
      </div>
    </div>
  )
}

export default LMSTeamDashboard
